export default "__VITE_ASSET__8db434d5__"